
// => Styling
import styles from './Modal.module.css';


// ============
// Component
// ============
const Modal = ({
    allowBackgroundClick = false,
    onBackgroundClick = () => {},
    children
}) => {

    const clicked = (e) => {
        if (!allowBackgroundClick) {
            return
        }
        onBackgroundClick()
    }


    // RENDER
    // ---------
    return(
        <div className={styles.container} onClick={clicked}>
            {children}
        </div>
    );
}


export default Modal